window.TVA_AUTH = window.TVA_AUTH || {};

window.TVA_AUTH.RegistrationFormPage = function() {

    /**
     * join country code + phone number from "PhoneNumberInput" component to hidden input field for form submission
     */
    const setupMobilePhoneInput = function() {
        const mobilePhoneHiddenInput = document.getElementById('mobile_phone');
        const countryCodeInput = document.getElementById('phctry');
        const phoneNumberInput = document.getElementById('temp_mobile_phone');

        const updateMobilePhoneNumber = function() {
            const prefix = countryCodeInput.value !== '+1' ? countryCodeInput.value : '';
            const phoneNumber = phoneNumberInput.value;
            mobilePhoneHiddenInput.value = [prefix, phoneNumber].filter(Boolean).join(' ');
        };

        countryCodeInput.addEventListener('change', updateMobilePhoneNumber);
        phoneNumberInput.addEventListener('change', updateMobilePhoneNumber);
    };

    /**
     * copy email to username field while username was not manually changed
     */
    const setupUsernameInput = function() {
        const emailInput = document.getElementById('email');
        const usernameInput = document.getElementById('username');
        let usernameTouched = usernameInput.value !== emailInput.value;

        const updateUsername = function() {
            if (!usernameTouched) {
                usernameInput.value = emailInput.value;
            }
        };

        const usernameChange = function() {
            usernameTouched = true;
        };

        emailInput.addEventListener('input', updateUsername);
        usernameInput.addEventListener('input', usernameChange);
    };

    const setup = function() {
        setupMobilePhoneInput();
        setupUsernameInput();
    };

    const init = function() {
        if (document.readyState !== 'loading') {
            setup();
        } else {
            document.addEventListener('DOMContentLoaded', setup);
        }
    }

    return {
        init: init
    };
};
